type Policy = { allowsFeature: (feature: string) => boolean; features?: () => string[] }

type PolicyDocument = Document & { permissionsPolicy?: Policy; featurePolicy?: Policy }

// Whether the host page's iframe `allow` lets the embed use a feature. A browser
// without the API, or one that doesn't list the feature (allowsFeature is then
// always false), answers at the call instead, so it counts as allowed here.
export function allowsFeature(feature: string) {
  const { permissionsPolicy, featurePolicy } = document as PolicyDocument
  const policy = permissionsPolicy ?? featurePolicy
  if (!policy) return true

  const known = policy.features?.().includes(feature) ?? true
  return !known || policy.allowsFeature(feature)
}
